import { useState } from "react";
import { useParams } from "react-router-dom";
import Modal from "react-modal";
import { useLoader } from "@/context/loaderContext";
import api from "@/components/customAxios/Axios";
import { useToast } from "../toast";
Modal.setAppElement("#root");
const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		padding: "2rem",
		borderRadius: "10px",
		maxWidth: "700px",
		width: "80%",
		maxHeight: "650px",
		zIndex: 1000,
	},
};
const RegenerateQuestionModal = ({
	questionId,
	questionType,
	getQuestions,
}: {
	questionId: string | number;
	questionType: string;
	getQuestions: () => void;
}) => {
	const toast = useToast();
	const { setLoading } = useLoader();
	const { id } = useParams();
	const [modalIsOpen, setIsOpen] = useState(false);
	const [difficulty, setDifficulty] = useState("Easy");
	const [prompt, setPrompt] = useState("");
	function closeModal() {
		setIsOpen(false);
	}

	const RegenerateQuestion = async () => {
		try {
			setLoading(true);
			const response = await api.post("update_job_question", {
				job_id: id,
				topic_prompt: prompt,
				question_index: questionId,
				difficulty_level: difficulty,
				question_type: questionType,
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 5000,
					status: "success",
					title: "Question Regenerated Successfully",
					description: "The question has been regenerated successfully.",
					open: true,
				});
				getQuestions();
				closeModal();
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Regenerating Question",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to regenerate the question. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	function openModal() {
		setIsOpen(true);
	}

	return (
		<div className="">
			<div className="relative group">
				<button
					onClick={openModal}
					className="text-lg font-heading font-semibold hover:scale-110 transition"
				>
					<svg
						width="17"
						height="17"
						viewBox="0 0 17 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M14.0494 2.86795C11.3273 0.185866 7.14037 -0.114786 4.08712 1.93976L4.07857 0.760291C4.07713 0.561773 3.91498 0.401995 3.71639 0.403576L2.99771 0.409182C2.79926 0.410691 2.6397 0.57277 2.64114 0.771145L2.66098 3.46107C2.66378 3.85623 2.98528 4.17421 3.37973 4.17421C3.38116 4.17421 3.38325 4.17421 3.38533 4.17421L6.07561 4.15437C6.27413 4.15294 6.43384 3.99071 6.43233 3.79219L6.42672 3.07337C6.42521 2.87493 6.26314 2.71536 6.06476 2.7168L5.60749 2.72011C8.01372 1.51893 11.02 1.90138 13.0401 3.89131C14.9787 5.80232 15.5084 8.67517 14.4068 11.1385C14.3284 11.3139 14.3926 11.5183 14.5637 11.6057L15.2052 11.9335C15.3869 12.0263 15.6168 11.9515 15.7012 11.7657C17.0716 8.74675 16.4293 5.21403 14.0494 2.86795ZM13.6205 12.8259C13.619 12.8259 13.617 12.8259 13.6149 12.8259L10.9246 12.8456C10.7261 12.8472 10.5664 13.0093 10.5679 13.2078L10.5735 13.9266C10.575 14.125 10.7371 14.2846 10.9354 14.2832L11.3923 14.2799C8.9859 15.4808 5.98009 15.098 3.96012 13.1087C2.0215 11.1977 1.49179 8.32478 2.59341 5.86148C2.67183 5.6861 2.60757 5.48176 2.43651 5.39429L1.79503 5.06654C1.61325 4.97368 1.3834 5.0485 1.29902 5.23429C-0.071495 8.25319 0.570852 11.7859 2.95071 14.1321C4.48854 15.6475 6.49465 16.4027 8.49924 16.4027C10.0428 16.4027 11.5848 15.9534 12.9129 15.0594L12.9214 16.2396C12.9229 16.4382 13.085 16.5979 13.2836 16.5964L14.0023 16.5908C14.2007 16.5892 14.3603 16.4272 14.3588 16.2288L14.339 13.5389C14.3364 13.1438 14.015 12.8259 13.6205 12.8259Z"
							fill="black"
						/>
					</svg>
				</button>
				<p className="absolute w-max text-center right-2 top-6 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
					Re-Generate Prompt
				</p>
			</div>

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<h2 className="text-xl font-semibold mb-2 text-center font-heading">
					Update Question
				</h2>
				<div className="mb-4 font-body">
					<label className="block mb-2">Select Difficulty Level:</label>
					<div className="flex space-x-4">
						{["Easy", "Medium", "Hard"].map((level) => (
							<button
								key={level}
								className={`px-4 py-2 rounded 
                                       text-[#438437] ${difficulty === level
										? "bg-[#BDE4C3] "
										: "border-1"
									}`}
								onClick={() => setDifficulty(level)}
							>
								{level}
							</button>
						))}
					</div>
				</div>
				<div className="mb-4">
					<label htmlFor="question" className="block mb-2 font-subheading">
						Enter Prompt:
					</label>
					<textarea
						id="question"
						className="border border-gray-300 rounded px-2 py-1 w-full"
						rows={5}
						value={prompt}
						onChange={(e) => setPrompt(e.target.value)}
					></textarea>
				</div>

				<div className="flex justify-end gap-2">
					<button
						className="bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded"
						onClick={RegenerateQuestion}
						disabled={!prompt.trim()}
					>
						Update
					</button>
					<button
						className="border-1 text-[#438437]  px-4 py-2 rounded"
						onClick={closeModal}
					// disabled={updating}
					>
						Cancel
					</button>
				</div>
			</Modal>
		</div>
	);
};

export default RegenerateQuestionModal;
